(() => {
  if (window.__searchSparkleInit) {
    return;
  }

  window.__searchSparkleInit = true;

  const SVG_SPARKLES = `
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 2.8l1.45 4.25a5.5 5.5 0 0 0 3.5 3.5L21.2 12l-4.25 1.45a5.5 5.5 0 0 0-3.5 3.5L12 21.2l-1.45-4.25a5.5 5.5 0 0 0-3.5-3.5L2.8 12l4.25-1.45a5.5 5.5 0 0 0 3.5-3.5L12 2.8z"></path>
  </svg>
`;


  /* =========================================================
     CSS
     ========================================================= */

  function injectStyles() {
    if (document.getElementById("athens-search-sparkle-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "athens-search-sparkle-styles";

    style.textContent = `
      .athens-search-sparkle {
  position: absolute;
  z-index: 3;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  pointer-events: none;

  color: #d90429;
  opacity: 0.92;

  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    filter 0.18s ease;
}

      .athens-search-sparkle svg {
  display: block;
  width: 19px;
  height: 19px;

  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;

  filter: drop-shadow(0 0 2px rgba(217, 4, 41, 0.18));
}

      .athens-search-sparkle.is-hidden {
        opacity: 0;
        transform: scale(0.9);
      }

      .athens-search-sparkle.is-pulsing svg {
  animation: athensSearchSparklePulse 2.8s ease-in-out infinite;
}

@keyframes athensSearchSparklePulse {
  0%,
  65%,
  100% {
    transform: scale(1);
    opacity: 0.95;
    filter: drop-shadow(
      0 0 2px rgba(217, 4, 41, 0.18)
    );
  }

  78% {
    transform: scale(1.10);
    opacity: 1;
    filter: drop-shadow(
      0 0 6px rgba(217, 4, 41, 0.38)
    );
  }

  88% {
    transform: scale(1.04);
    opacity: 0.98;
    filter: drop-shadow(
      0 0 3px rgba(217, 4, 41, 0.24)
    );
  }
}

      @media (prefers-reduced-motion: reduce) {
        .athens-search-sparkle,
        .athens-search-sparkle svg {
          transition: none;
          animation: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }


  /* =========================================================
     SETUP
     ========================================================= */

  function setupComponent(component) {
  if (!component) {
    return;
  }

  if (
    component.dataset.searchSparkleReady === "true"
  ) {
    return;
  }

  const form =
    component.querySelector(
      "form.search"
    );

  const input =
    component.querySelector(
      'input[type="search"]'
    );

  const sparkle =
    component.querySelector(
      ".athens-search-sparkle"
    );

  const submitButton =
    form?.querySelector(
      'button[type="submit"]'
    );

  if (
    !form ||
    !input ||
    !sparkle
  ) {
    return;
  }

  component.dataset.searchSparkleReady =
    "true";

  const formStyle =
    window.getComputedStyle(form);

  if (
    formStyle.position === "static"
  ) {
    form.style.position =
      "relative";
  }

  function positionSparkle() {
    const formRect =
      form.getBoundingClientRect();

    const inputRect =
      input.getBoundingClientRect();

    if (
      !inputRect.width ||
      !inputRect.height
    ) {
      return;
    }

    const iconSize = 24;
    const gapFromButton = 14;

    let rightBoundary =
      inputRect.right;

    /*
     * Put the Sparkle immediately
     * BEFORE the Athens Search button.
     */
    if (submitButton) {
      const buttonRect =
        submitButton.getBoundingClientRect();

      rightBoundary =
        buttonRect.left;
    }

    const left =
      rightBoundary -
      formRect.left -
      iconSize -
      gapFromButton;

    const top =
  inputRect.top -
  formRect.top +
  inputRect.height / 2;

    sparkle.style.left =
  `${left}px`;

sparkle.style.top =
  `${top}px`;

sparkle.style.right =
  "auto";

sparkle.classList.add(
  "is-positioned"
);
  }

  function syncVisibility() {
    const shouldHide =
      document.activeElement === input ||
      Boolean(
        input.value &&
        input.value.trim().length > 0
      );

    sparkle.classList.toggle(
      "is-hidden",
      shouldHide
    );
  }

  positionSparkle();
syncVisibility();

  window.addEventListener(
    "load",
    () => {
      requestAnimationFrame(() => {
        positionSparkle();
        syncVisibility();
      });
    }
  );

  window.addEventListener(
    "resize",
    () => {
      requestAnimationFrame(() => {
        positionSparkle();
        syncVisibility();
      });
    },
    {
      passive: true
    }
  );

  input.addEventListener(
    "focus",
    syncVisibility
  );

  input.addEventListener(
    "blur",
    () => {
      requestAnimationFrame(
        syncVisibility
      );
    }
  );

  input.addEventListener(
    "input",
    syncVisibility
  );

  document.addEventListener(
    "search:open",
    () => {
      requestAnimationFrame(() => {
        positionSparkle();
        syncVisibility();
      });
    }
  );

  if (
    "ResizeObserver" in window
  ) {
    const observer =
      new ResizeObserver(
        () => {
          requestAnimationFrame(() => {
            positionSparkle();
            syncVisibility();
          });
        }
      );

    observer.observe(input);
  }
}


  /* =========================================================
     INIT
     ========================================================= */

  function initAll(root) {
    injectStyles();

    const scope = root || document;

    scope.querySelectorAll("predictive-search").forEach((component) => {
      setupComponent(component);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  window.addEventListener("load", () => initAll());

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();